import * as React from 'react';

import { useIntl } from 'react-intl';

import styled from 'styled-components';

export const CSSIsEmpty = styled.div`
    padding: 24px;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
`;

export const DriveIsEmpty = () => {
    const intl = useIntl();
    return <CSSIsEmpty>{intl.formatMessage({ id: 'DRIVE_Is_Empty' })}</CSSIsEmpty>;
};
